import { render, staticRenderFns } from "./ZnCurriculumUnitConvert.vue?vue&type=template&id=1dc379fb&scoped=true&lang=pug&"
import script from "./ZnCurriculumUnitConvert.vue?vue&type=script&lang=ts&"
export * from "./ZnCurriculumUnitConvert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc379fb",
  null
  
)

export default component.exports